/**
 * 全站共享静态资源 URL（主应用 / 子应用共用同一份文件）。
 * 部署产物：dist/{brand}/shared-assets/… → 线上路径 /shared-assets/…
 */
export const SHARED_ASSETS_PUBLIC_PATH = "/shared-assets";

/** 将 shared-assets/src 下相对路径转为站点绝对 URL */
export function sharedAssetUrl(relativePath: string): string {
  const clean = String(relativePath || "")
    .replace(/\\/g, "/")
    .replace(/^\/+/, "");
  return `${SHARED_ASSETS_PUBLIC_PATH}/${clean}`;
}
